// Utility functions to generate PKCE code verifier and challenge

// Generates a random string for PKCE code verifier
export const generateCodeVerifier = (length: number = 64): string => {
  const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  let array = new Uint8Array(length)
  if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(array)
  } else {
    // Fallback for environments without crypto
    for (let i = 0; i < length; i++) {
      array[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(array)
    .map((x) => validChars[x % validChars.length])
    .join('')
}

// Base64 URL encode
const base64UrlEncode = (arrayBuffer: ArrayBuffer): string => {
  let str = String.fromCharCode.apply(null, Array.from(new Uint8Array(arrayBuffer)) as unknown as number[])
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// Creates a SHA-256 based code challenge from a verifier
export const createCodeChallenge = async (codeVerifier: string): Promise<string> => {
  const encoder = new TextEncoder()
  const data = encoder.encode(codeVerifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return base64UrlEncode(digest)
}

